module.exports = __webpack_public_path__ + "static/img/credit-wuhu-1.673249f4.jpg";